import {ConfEnv} from "../../../../config/config";
import privateRequest from "../../../../Infra/http/private.request";

// Unified Lottery Ticket Creation Service
// Endpoint: POST /api/v1/lottery/ticket
// Accepts: { currency, items: [{ draw_id, bets: [{ numbers, amount, sign_id }] }] }
export const postCreateTicketService = data => {
  const url = `${ConfEnv.BASE_URL}/lottery/ticket`;
  return privateRequest.post(url, data);
};
